package com.essntl.components.multiselect

import androidx.compose.foundation.Canvas
import androidx.compose.foundation.gestures.detectDragGestures
import androidx.compose.foundation.layout.Box
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.graphics.drawscope.DrawScope
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.layout.onGloballyPositioned
import androidx.compose.ui.layout.positionInRoot

@Composable
fun MultiSelectContainer(
    state: MultiSelectState,
    drawSelection: DrawScope.(topLeft: Offset, size: Size) -> Unit,
    enabled: Boolean = true,
    modifier: Modifier = Modifier,
    content: @Composable () -> Unit
) {
    Box(
        modifier = modifier
            .onGloballyPositioned {
                state.containerPositionInRoot = it.positionInRoot()
            }
            .pointerInput(state, enabled) {
                if (!enabled)
                    return@pointerInput

                detectDragGestures(
                    onDragStart = { offset ->
                        state.handleDragStart(
                            offset = offset,
                        )
                    },
                    onDrag = { change, _ ->
                        change.consume()
                        state.handleDrag(
                            offset = change.position,
                        )
                    },
                    onDragEnd = {
                        state.handleDrop()
                    },
                    onDragCancel = {
                        state.handleDrop()
                    },
                )
            }
    ) {
        content()

        Canvas(
            modifier = Modifier
                .matchParentSize()
        ) {
            if (state.isSelecting)
                drawSelection(
                    state.selectionTopLeft - state.containerPositionInRoot,
                    state.selectionSize
                )
        }
    }
}